import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DailyTotalsDetailsPage } from './daily-totals-details';
import { MatIconModule, MatListModule } from '@angular/material';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [
    DailyTotalsDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(DailyTotalsDetailsPage),
    MatIconModule,
    MatListModule,
    CommonModule,
    FlexLayoutModule
  ],
})
export class DailyTotalsDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/daily-totals-details/daily-totals-details.module.ts